import brandEventPropertyMapper from "./brandEventPropertyMapper";
import getParsedRedirectUrl from "./getParsedRedirectUrl";

const productEventPropertyMapper = ({
	brand = {},
	brandIdx,
	idx,
	product,
	upsell = false,
	feedHasUpsell = false,
}) => {
	if (!product || typeof product !== "object") return {};
	const {
		name,
		id: productId,
		masked_url: productUrl,
		price_str: price,
		discounted_price_str: discountedPrice,
	} = product;

	const { self = false } = brand;
	upsell = upsell || self;

	let redirectUrl = productUrl;

	redirectUrl = getParsedRedirectUrl({ brand, upsell, redirectUrl });
	const brandEventProps = brandEventPropertyMapper({
		brand,
		idx: brandIdx,
		upsell,
		feedHasUpsell,
	});

	const defaultEventProps = {
		...brandEventProps,
		product: name,
		product_id: productId,
		product_view_order: idx,
		// show_coop_pdp: false, TODO:
		price: price || "",
		product_link: productUrl,
		discounted_price: discountedPrice || "",
		product_redirect_link: redirectUrl,
	};

	return defaultEventProps;
};

export default productEventPropertyMapper;
